module.exports = __webpack_public_path__ + "fonts/SEBSansSerif-Medium.210aef8a.woff2";